var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 33.3333H6.66665M6.66665 33.3333H23.3333M6.66665 33.3333V10.3337C6.66665 8.46682 6.66665 7.5327 7.02996 6.81966C7.34954 6.19245 7.8591 5.68289 8.48631 5.36331C9.19935 5 10.1335 5 12.0003 5H18.0003C19.8671 5 20.7993 5 21.5123 5.36331C22.1395 5.68289 22.6508 6.19245 22.9704 6.81966C23.3333 7.532 23.3333 8.46499 23.3333 10.3282V20M23.3333 33.3333H33.3333M23.3333 33.3333V20M33.3333 33.3333H36.6666M33.3333 33.3333V20C33.3333 18.4469 33.3331 17.6707 33.0794 17.0581C32.7411 16.2413 32.0928 15.592 31.276 15.2537C30.6635 15 29.886 15 28.3329 15C26.7797 15 26.0032 15 25.3906 15.2537C24.5738 15.592 23.9254 16.2413 23.587 17.0581C23.3333 17.6707 23.3333 18.4469 23.3333 20M11.6666 16.6667H18.3333M11.6666 11.6667H18.3333",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon1);
export default __webpack_public_path__ + "static/media/discoverItemIcon1.7ae010473357e576d69a57a1d8a6c348.svg";
export { ForwardRef as ReactComponent };